import { render, staticRenderFns } from "./index.html?vue&type=template&id=b5dcde10&scoped=true&external"
import script from "./XacMinhCode.vue?vue&type=script&lang=js"
export * from "./XacMinhCode.vue?vue&type=script&lang=js"
import style0 from "./XacMinhCode.vue?vue&type=style&index=0&id=b5dcde10&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5dcde10",
  null
  
)

export default component.exports